import { TrackClickConfig } from '../../../models';

export const DEFAULT_TRACK_CLICK_CONFIG: TrackClickConfig = {
  storage: {
    urlTTLInMs: 60 * 1000
  }
};
